import { render } from "./Searchbar.vue?vue&type=template&id=67ab65ba"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"

import "./Searchbar.vue?vue&type=style&index=0&id=67ab65ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__